import { AddStoreForm } from '@/features/store-management/basic-stores/form/AddStoreForm';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/add-store/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="bg-card  p-8 rounded-lg !w-full">
      <AddStoreForm />
    </div>
  );
}
